export default __webpack_public_path__ + "static/five-instructions-f61829b7e0796144ba049dc458f6ea20.png";